import { render, staticRenderFns } from "./ContractInformativeServices.vue?vue&type=template&id=d77e9108&scoped=true"
import script from "./ContractInformativeServices.vue?vue&type=script&lang=js"
export * from "./ContractInformativeServices.vue?vue&type=script&lang=js"
import style0 from "./ContractInformativeServices.vue?vue&type=style&index=0&id=d77e9108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77e9108",
  null
  
)

export default component.exports